// @ts-nocheck
import unitsData from '../../../../../shims/appStub';
import materialsData from '../../../../../shims/appStub';
import type {
  MaterialDefinition,
  MaterialsDataAsset,
  UnitDefinition,
  UnitsCatalog,
  UnitsDataAsset,
} from './types';

function normalizeAliasKey(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

function buildAliasIndex(
  entries: ReadonlyArray<{ id: string; aliases: Readonly<Record<string, readonly string[]>> }>,
): Map<string, string> {
  const index = new Map<string, string>();
  for (const entry of entries) {
    index.set(normalizeAliasKey(entry.id), entry.id);
    for (const localeAliases of Object.values(entry.aliases)) {
      for (const alias of localeAliases) {
        index.set(normalizeAliasKey(alias), entry.id);
      }
    }
  }
  return index;
}

function validateUnitsAsset(raw: UnitsDataAsset): UnitsDataAsset {
  if (raw.version !== 1) {
    throw new Error(`Unsupported units.data.json version: ${raw.version}`);
  }
  return raw;
}

function validateMaterialsAsset(raw: MaterialsDataAsset): MaterialsDataAsset {
  if (raw.version !== 1) {
    throw new Error(`Unsupported materials.data.json version: ${raw.version}`);
  }
  return raw;
}

let cachedCatalog: UnitsCatalog | null = null;

export function loadUnitsCatalog(): UnitsCatalog {
  if (cachedCatalog) {
    return cachedCatalog;
  }

  const unitsAsset = validateUnitsAsset(unitsData as UnitsDataAsset);
  const materialsAsset = validateMaterialsAsset(materialsData as MaterialsDataAsset);

  const unitsById = new Map<string, UnitDefinition>();
  for (const unit of unitsAsset.units) {
    unitsById.set(unit.id, unit);
  }

  const materialsById = new Map<string, MaterialDefinition>();
  for (const material of materialsAsset.materials) {
    materialsById.set(material.id, material);
  }

  cachedCatalog = {
    unitsById,
    materialsById,
    aliasIndex: buildAliasIndex(unitsAsset.units),
    materialAliasIndex: buildAliasIndex(materialsAsset.materials),
    baseUnits: unitsAsset.baseUnits,
    rounding: unitsAsset.rounding,
  };

  return cachedCatalog;
}

/** Test-only: reset cached catalog between tests. */
export function resetUnitsCatalogCacheForTests(): void {
  cachedCatalog = null;
}

export { normalizeAliasKey };
